import React, { useEffect, useCallback, useState } from 'react';
import { MessageBar, Checkbox, Spinner, SpinnerSize } from '@fluentui/react';
import { Link } from '@bingads-webui-react/fabric-with-signal';
import PropTypes from 'prop-types';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import BlockUi from 'react-block-ui';

const NetflixTCAgreement = ({ i18n, cid, aid }) => {
  const [fetched, setFetched] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const readAccount = useCallback(() => edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .get({ select: ['NetflixTCAccepted'] })
    .toPromise(), [aid, cid]);

  const patchAccount = useCallback(() => edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .patch({ NetflixTCAccepted: 'true' })
    .toPromise(), [aid, cid]);

  const onAccept = useCallback(() => {
    setFetched(false);
    patchAccount()
      .then(() => {
        setAccepted(true);
        setFetched(true);
      });
  }, [patchAccount]);

  useEffect(() => {
    readAccount().then((account) => {
      setFetched(true);
      setAccepted(account.NetflixTCAccepted === 'true');
    });
  }, [readAccount]);

  return (
    <BlockUi className="react-blocker" blocking={!fetched} loader={<Spinner size={SpinnerSize.small} />} >
      <Checkbox
        label={
          <>
            <span>{i18n.getString(_TL_('I have read and agree to the '))}</span>
            <Link href="https://about.ads.microsoft.com/en-us/microsoft-advertising-netflix-inventory-policy.pdf" target="_blank">
              {i18n.getString(_TL_('Netflix Inventory Policy'))}
            </Link>
            <span>{i18n.getString(_TL_('.'))}</span>
          </>
        }
        checked={accepted}
        onChange={onAccept}
        disabled={accepted}
        defaultChecked={false}
      />
      <MessageBar>
        {i18n.getString(_TL_('To be eligible to show ads on Netflix, your campaigns must meet all Netflix requirements, such as containing a bid, having a certain video quality and adhering to Netflix’s policies.'))}
      </MessageBar>
      <MessageBar>
        <span>
          {
            i18n.getString(_TL_('Advertisers in the following verticals are required to submit their licenses and/or proof of creative approval in select markets to serve their ads on Netflix: Alcohol, Financial Services, Insurance, High fat/sugar/salt foods, online sports betting, state-run lotteries, healthcare, pharmaceuticals, and dating.  Licenses and proof of creative approval can be submitted in web forms linked through the'))
          }
        </span>
        <Link href="https://help.netflix.com/legal/ad-restrictions" target="_blank">
          {i18n.getString(_TL_('Restricted policy page.'))}
        </Link>
      </MessageBar>
    </BlockUi>
  );
};

NetflixTCAgreement.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  cid: PropTypes.number.isRequired,
  aid: PropTypes.number.isRequired,
};

export { NetflixTCAgreement };
